import "./style.css";

export default class MainNav {
  static selector = ".main-nav";

  constructor(block) {
    this.block = block;

    this.mobileMenuTrigger = this.block.querySelector("#main-nav-trigger");

    this.mobileMenuTrigger.addEventListener("click", this.handleToggleMenu);
  }

  handleToggleMenu = () => {
    document.body.classList.toggle("mobile-menu-is-open");
    if (document.body.classList.contains("mobile-menu-is-open")) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  };

  // Public methods
  onResize() {
    if (window.App.getCurrentView() === "laptop") {
      document.body.classList.remove("mobile-menu-is-open");
      document.body.classList.remove("no-scroll");
    }
  }
  onScroll() {}

  onDestroy() {
    this.mobileMenuTrigger.removeEventListener("click", this.handleToggleMenu);
  }
}
